import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Dropdown, Modal } from "semantic-ui-react";
import { useV2createChatSessionMutation } from "./chatSessionApiSlice";

const languageOptions = [
  {
    key: "en",
    text: "English",
    value: "en",
  },
  {
    key: "ko",
    text: "한국어",
    value: "ko",
  },
  {
    key: "ja",
    text: "日本語",
    value: "ja",
  },
  {
    key: "zh",
    text: "中文",
    value: "zh",
  },
];

const ModelOptions = [
  { key: "OpenAI", text: "OpenAI", value: "OPENAI" },
  { key: "Custom model", text: "Custom model", value: "v2-745-gptq" },
];

const promptOptions = [
  {
    key: "0",
    text: "prompt0",
    value: "prompt0",
  },
  {
    key: "1",
    text: "prompt1",
    value: "prompt1",
  },
  {
    key: "2",
    text: "prompt2",
    value: "prompt2",
  },
  {
    key: "3",
    text: "prompt3",
    value: "prompt3",
  },
  {
    key: "4",
    text: "testing",
    value: "prompt4",
  },
  {
    key: "5",
    text: "prompt5",
    value: "prompt5",
  },
  {
    key: "5",
    text: "prompt_custom",
    value: "prompt_custom",
  },
];

function V2chatSessionCreateModal({ trigger }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [language, setLanguage] = useState(languageOptions[0].value);
  const [model, setModel] = useState(ModelOptions[0].value);
  const [prompt, setPrompt] = useState(promptOptions[5].value);

  const [createChatSession, { data: created_chatsession }] =
    useV2createChatSessionMutation();

  const handleStart = () => {
    let llm_model = model;
    if (llm_model === ModelOptions[1].value) {
      createChatSession({
        language,
        llm_model,
        prompt: promptOptions[5].value,
      });
    } else createChatSession({ language, llm_model, prompt });
  };

  useEffect(() => {
    if (created_chatsession) {
      navigate(
        `/chatsessionperform-v2?chatsession_id=${created_chatsession.id}`
      );
      setOpen(false);
      window.location.reload();
    }
  }, [created_chatsession, navigate]);

  useEffect(() => {
    setModel(ModelOptions[0].value);
  }, [open]);

  return (
    <Modal
      style={{ width: "43%" }}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={trigger}
    >
      <Modal.Header>Select Session Parameters</Modal.Header>
      <Modal.Actions style={{ display: "flex", justifyContent: "center" }}>
        <Dropdown
          position="center"
          button
          className="icon"
          labeled
          icon="language"
          defaultValue="en"
          onChange={(event, data) => {
            setLanguage(data.value);
          }}
          options={languageOptions}
        />
        <Button content="Create" onClick={handleStart} positive />
      </Modal.Actions>
    </Modal>
  );
}

export default V2chatSessionCreateModal;
